import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../app.constants';
import { BeneficioPropDiferidoModel } from '../../shared/models/beneficio-prop-diferido.model';
import { PessoaDadosSimplicadosModel } from '../../shared/models/pessoa-simplificada.model';
import { BPDPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/beneficio-proprio-diferido/bpd-pdf';
import { PessoaService } from '../../shared/services/pessoa.service';
import { DateUtilService } from '../../shared/util/date-util.service';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { BeneficioProporcionalDiferidoService } from './service/beneficio-proporcional-diferido.service';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';

@Component({
  selector: 'app-beneficio-proporcional-diferido',
  templateUrl: './beneficio-proporcional-diferido.component.html',
  styleUrls: ['./beneficio-proporcional-diferido.component.css']
})
export class BeneficioProporcionalDiferidoComponent implements OnInit {

  componentes: any[] = [1];
  @BlockUI() blockUi: NgBlockUI;

  beneficioPropDiferidoModel = new Array<BeneficioPropDiferidoModel>();

  pessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();


  cdCentrus: number;
  cdCentrusTit: number;

  param: string;
  mensagemSuperior: string;
  page = 0;
  rows = 14;
  totalRecords = 0;

  constructor(
    private beneficioProporcionalDiferidoService: BeneficioProporcionalDiferidoService,
    private pessoaService: PessoaService,
    private dateUtilService: DateUtilService,
    private bPDPdf: BPDPdf,
    private toastrService: ToastrService,
    private authInterceptor: AuthInterceptor,
    private router: Router
  ) { }

  ngOnInit() {


    this._gerenciarCodigoIndentificao();

  }

   getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param =  '/cardMenus/cardMenuPlanos';
        }
        this.getPessoasDadosSimplificado();
      })
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getCdCentrusTitular();

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }




  async getCdCentrusTitular() {
    try {
      this.cdCentrusTit = await this.pessoaService.getCdCentrusTitular(this.cdCentrus);
     if (!this.cdCentrusTit) {this.cdCentrusTit = this.cdCentrus};

      this.getconsultarBPD();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  paginacao(evento) {
    this.page = evento['page'];
    this.rows = evento['rows'];
    this.getconsultarBPD();
  }

  async getconsultarBPD() {

    try {
      const beneficioPropDiferidoPag = await this.beneficioProporcionalDiferidoService.getConsultarPageBPD(this.cdCentrus, this.cdCentrusTit, this.rows, this.page);

      this.totalRecords = beneficioPropDiferidoPag['totalElements'];
      this.beneficioPropDiferidoModel = this._configurandoLista(beneficioPropDiferidoPag['content']);

     if (this.beneficioPropDiferidoModel.length <= 0) {this.voltarForcada()};

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async imprimirPagina() {
    this.blockUi.start('Carregando...');
    const beneficioPropDiferidoPag = await this.beneficioProporcionalDiferidoService.getConsultarBPD(this.cdCentrus, this.cdCentrusTit);
    this.bPDPdf.funcionarios(
      this.pessoaDadosSimplicadosModel,
      this._configurandoLista(beneficioPropDiferidoPag));
    this.blockUi.stop();
  }




  private _configurandoLista(beneficioPropDiferidoPag: Array<BeneficioPropDiferidoModel>): Array<BeneficioPropDiferidoModel> {
    return beneficioPropDiferidoPag.map((item, index, list) => {
      const beneficioPropDiferido = new BeneficioPropDiferidoModel();


      if (item.dsOcorrencia === 'ATUALIZACAO') {
        beneficioPropDiferido.dtReferencia = this.dateUtilService._formatData(item.dtReferencia);
      }

      if (item.tpOcorrencia === '1001') {
        if (index === 0) {
          this.mensagemSuperior = 'PARCELAS CREDITADAS NO MES Nº 1 A 24'
        } else {
          beneficioPropDiferido.dsOcorrencia = `${item.dsOcorrencia} Nº ${item.nrParcela}`
        }
      } else {
        beneficioPropDiferido.dsOcorrencia = item.dsOcorrencia
      }

      beneficioPropDiferido.vlOcor = item.vlOcor;
      beneficioPropDiferido.vlSaldo = item.vlSaldo;

      return beneficioPropDiferido;
    })
  }


  voltarForcada(): void {
     this.router.navigate([this.param]);
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/beneficio-proporcional-diferido/beneficio-proporcional-diferido.component.ts